import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableContainer, TableSortLabel } from "@mui/material";

import { CommonButton } from "@/components/common/buttons/CommonButton";
import { Pagination } from "@/components/molecules/Pagination";
import { ChargerExcludeConstants } from "./ChargerExcludeConstants";
import { PaginationType } from "@/models/common";
import { ChargerExcludeModel } from "@/models/chargerExclude";
import {
  ChargerExcludeSortKey,
  ChargerExcludeOrderTypes,
} from "@/models/chargerExclude";
import { getShortDatetime } from "@/util/datetime";

export type ChargerExcludeListProps = {
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  chargerExclude: ChargerExcludeModel[];
  orderTypes: ChargerExcludeOrderTypes;
  onClickChangeSort: (key: ChargerExcludeSortKey) => void;
  onClickDetail: (id: number) => void;
};

export const ChargerExcludeList = (props: ChargerExcludeListProps) => {
  const {
    onChangePage,
    chargerExclude,
    pagingData,
    orderTypes,
    onClickChangeSort,
    onClickDetail,
  } = props;

  return (
    <React.Fragment>
      <TableContainer className="table-container-width">
        <Table size="small">
          <TableHead className="list-head">
            <TableRow>
              <TableCell className="table-cell-width-custom">
                {" "}
                {ChargerExcludeConstants.InstallationLocation}
                {"\n"}
                <span style={{ marginLeft: -5 }}>
                  {ChargerExcludeConstants.SaleOffices}
                </span>
                <TableSortLabel
                  active={
                    chargerExclude.length &&
                    !!orderTypes["chargers.offices.displayName"]
                      ? true
                      : false
                  }
                  direction={
                    orderTypes["chargers.offices.displayName"] === "desc"
                      ? "desc"
                      : "asc"
                  }
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() =>
                    onClickChangeSort("chargers.offices.displayName")
                  }
                />
              </TableCell>
              <TableCell className="table-cell-width-custom">
                {ChargerExcludeConstants.ChargerName}
                <TableSortLabel
                  active={
                    chargerExclude.length && !!orderTypes["chargers.name"]
                      ? true
                      : false
                  }
                  direction={
                    orderTypes["chargers.name"] === "desc" ? "desc" : "asc"
                  }
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("chargers.name")}
                />
              </TableCell>
              <TableCell className="table-cell-width-custom">
                {ChargerExcludeConstants.SuspensionOfUseStartDate}
              </TableCell>
              <TableCell className="table-cell-width-custom" colSpan={2}>
                {ChargerExcludeConstants.Reason}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {chargerExclude.map((row) => (
              <TableRow key={row.id} hover sx={{ wordBreak: "break-all" }}>
                <TableCell>{row.chargers?.offices?.displayName}</TableCell>
                <TableCell>{row.chargers?.name}</TableCell>
                <TableCell>{getShortDatetime(row.startAt)}</TableCell>
                <TableCell>{row.cause}</TableCell>
                <TableCell sx={{ textAlign: "right", pr: 0 }}>
                  <CommonButton
                    btnType="Detail"
                    onClickBtn={() => onClickDetail(row.id || 0)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size || 3}
        setPage={(page) => onChangePage(page)}
      />
    </React.Fragment>
  );
};
